import {images} from '../../../../constants'

export const PAYMENT_PROVIDER_CONFIG = [
    {
        name: 'Click',
        switchKey: 'click',
        logo: images.clickLogo,
        fields: [
            {key: 'click_pass_service_id', label: 'Pass service ID'},
            {key: 'click_pass_merchant_user_id', label: 'Pass merchant user ID'},
            {key: 'click_pass_secret_key', label: 'Pass secret key'},
            {key: 'click_qr_pay_service_id', label: 'QR Pay service ID'},
            {key: 'click_qr_pay_merchant_user_id', label: 'QR Pay merchant user ID'},
            {key: 'click_qr_pay_secret_key', label: 'QR Pay secret key'},
        ],
    },
    {
        name: 'Payme',
        switchKey: 'pay_me',
        logo: images.paymeLogo,
        fields: [
            {key: 'payme_subscribe_id', label: 'GO ID'},
            {key: 'payme_subscribe_token', label: 'GO token'},
            {key: 'payme_merchant_id', label: 'QR Pay ID'},
            {key: 'payme_merchant_token', label: 'QR Pay token'},
            {key: 'payme_merchant_test_token', label: 'QR Pay test token'},
            {key: 'payme_tip_id', label: 'Tip ID'},
            {key: 'payme_tip_token', label: 'Tip token'},
        ],
    },
    {
        name: 'Uzum',
        switchKey: 'apelsin',
        logo: images.uzumLogo,
        fields: [
            {key: 'apelsin_merchant_id', label: 'Merchant ID'},
            {key: 'apelsin_merchant_user_id', label: 'Merchant user ID'},
            {key: 'apelsin_merchant_service_id', label: 'Merchant service ID'},
            {key: 'apelsin_merchant_secret_key', label: 'Merchant secret key'},
        ],
    },
    {
        name: 'Anor',
        switchKey: 'anor',
        logo: images.anorLogo,
        fields: [
            {key: 'anor_secret_key', label: 'Secret key'},
            {key: 'anor_branch_id', label: 'Branch ID'},
        ],
    },
    {
        name: 'Yagona QR kod',
        switchKey: 'uzqr',
        logo: images.uzQrLogo,
        fields: [
            {key: 'uzqr_api_key', label: 'API key'},
            {key: 'uzqr_endpoint', label: 'Endpoint'},
            {key: 'uzqr_port', label: 'Port'},
        ],
    },
]
